export class SchoolCourseRequestModel {
    StudentCourseRequest_ID: number;
    DistrictCourse_ID: number;
    GradeLevel: string;
    LastName: string;
    FirstName: string;
    Student_ID: number;
    StudentNumber: string;
    CourseRequirement: string;
    CourseRequirement_ID?: number;
    Course: string;
    Credits: number;
    TermType: string;
    Status: string;
    Term: string;
    Period: string;
    Teacher: string;
    Teacher_ID: number;
    Section: string;
    Conflicts: number;
    Subject_ID: number;
    Type: string;
    PrimaryCourse: string;
    RequestPriority: number;
}
